@if (!(selectedFields$ | async).has(field.bindId)) {
  <ng-container
    [ngTemplateOutlet]="ButtonRef"
    [ngTemplateOutletContext]="{
      icon: 'add',
      extraIconClass: '',
      click: onAddField,
      title: ButtonConstants.Icon.addTitle
    }"
    >
  </ng-container>
} @else {
  <ng-container
    [ngTemplateOutlet]="ButtonRef"
    [ngTemplateOutletContext]="{
      icon: 'confirm-filled',
      extraIconClass: 'icon-success',
      click: onRemoveField,
      title: ButtonConstants.Icon.addedTitle
    }"
    >
  </ng-container>
}



<ng-template #ButtonRef let-icon="icon" let-extraIconClass="extraIconClass" let-click="click" let-title="title">
  <button
    [attr.data-automation-id]="ButtonConstants.Icon.automationId + '_' + icon"
    title="{{ title | translate }}"
    soho-button="icon"
    [icon]="icon"
    [extraIconClass]="extraIconClass"
    (click)="click()"
  ></button>
</ng-template>
